import { useAppSelector } from "@/store/store";
import {
  selectUserScore,
  selectUserScores,
} from "@/store/slices/scores/selectors";
import { useCallback, useState } from "react";
import { api, getEndpoint } from "@/api";
import { actionSetScore, actionSetUserScores } from "@/store/slices/scores";
import { useDispatch } from "react-redux";
import { logger } from "@/utils";

const useScores = () => {
  const dispatcher = useDispatch();
  const score = useAppSelector(selectUserScore);
  const userScores = useAppSelector(selectUserScores);

  const [loading, setLoading] = useState(false);

  const userProducts = userScores.filter((score) => score.action === "deduct");

  const getUserScore = useCallback(async () => {
    setLoading(true);

    try {
      const res = await api.get(getEndpoint("myScores"));
      const scores = res?.data?.data || [];
      console.log("scores", scores);
      dispatcher(actionSetUserScores(scores));

      const total = scores
        .filter((score: any) => score.is_claimed)
        .reduce(
          (sum: number, score: any) => sum + parseFloat(score.score_value),
          0,
        );

      dispatcher(actionSetScore(total));
    } catch (error) {
      logger.error("Failed to fetch user scores:", error);
    } finally {
      setLoading(false);
    }
  }, [dispatcher]);

  const claimUserScore = useCallback(
    async (scoreId: number) => {
      try {
        const res = await api.post(
          getEndpoint("claimMyScore", { id: scoreId }),
        );

        await getUserScore();

        return res?.data?.message || "Score claimed successfully.";
      } catch (error) {
        logger.error("Error claiming score:", error);
        throw error;
      }
    },
    [getUserScore],
  );

  return {
    score,
    userScores,
    userProducts,
    loading,
    getUserScore,
    claimUserScore,
  };
};

export default useScores;
